'use client'

/* eslint no-underscore-dangle: ["error", { "allow": ["_uid"] }] -- Block `_uid` is used as a value for tabs */

import { Tab, Tabs, TabsList } from '@mui/base'
import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC, type PropsWithChildren } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokTabsType } from '../../storyblok'

import { StoryblokTabChip } from './StoryblokTabChip'

import styles from './StoryblokTabs.module.css'

export const StoryblokTabsContent: FC<
  PropsWithChildren<StoryblokComponentProps<StoryblokTabsType>>
> = ({ blok, children }) => (
  <Tabs
    {...storyblokEditable(blok)}
    className={styles.tabs}
    defaultValue={blok.content.at(0)?._uid}
  >
    <TabsList className={styles.tabs__list}>
      {blok.content.map(({ _uid, label }) => (
        <Tab key={_uid} slots={{ root: StoryblokTabChip }} value={_uid}>
          {label}
        </Tab>
      ))}
    </TabsList>
    {children}
  </Tabs>
)
